<div class="page-header">
  <app-prev-next-button (click)="toDashboard()" [direction]="'left'" icon="estate"></app-prev-next-button>
  <h1>Gerenciamento de Endereços</h1>
</div>

<app-warehouse-map-table *ngIf="!selectedPositionId" (openPigeonhole)="openDetails($event)"></app-warehouse-map-table>
<app-warehouse-map-details *ngIf="selectedPositionId"
  [positionId]="selectedPositionId"
  (close)="clearDetails()">
</app-warehouse-map-details>